import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragment, fragmentArray } from 'ember-data-model-fragments/attributes';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type DataType from '@linc-technologies/linced-common/enums/data-type';
import type InputType from '@linc-technologies/linced-common/enums/input-type';
import type PersonType from '@linc-technologies/linced-common/enums/person-type';
import type Value from '@linc-technologies/linced-common/models/dynamic-field/value';
import type FieldOption from '@linc-technologies/linced-common/models/people-schema/field-option';
import type Group from 'linced-admin/models/people-schema/group';
import type Set from 'linced-admin/models/people-schema/set';

// Proto: people_schema.TemplateField.
export default class Field extends Model {
  declare [Type]: 'people-schema/field';

  @attr('number', { defaultValue: 0 })
  declare personType: EnumValue<typeof PersonType> | 0;

  @attr('number', { defaultValue: 0 })
  declare sequence: number;

  @attr('boolean', { defaultValue: false })
  declare isLocked: boolean;

  @attr('boolean', { defaultValue: false })
  declare isVisibleToParents: boolean;

  @attr('boolean', { defaultValue: false })
  declare isSiblingLinked: boolean;

  @attr('string', { defaultValue: '' })
  declare key: string;

  @attr('number', { defaultValue: 0 })
  declare inputType: EnumValue<typeof InputType> | 0;

  @attr('number', { defaultValue: 0 })
  declare dataType: EnumValue<typeof DataType> | 0;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @fragment('dynamic-field/value')
  declare default: Value | null;

  @attr('string', { defaultValue: '' })
  declare placeholder: string;

  @attr('boolean', { defaultValue: false })
  declare isRequired: boolean;

  @fragmentArray('people-schema/field-option')
  declare options: FragmentArray<FieldOption>;

  @attr('boolean', { defaultValue: false })
  declare optionsFromEnum: boolean;

  @attr({ defaultValue: () => ({}) })
  declare htmlAttributes: Record<string, unknown>;

  @belongsTo('people-schema/group', { async: true, inverse: 'fields' })
  declare templateGroupId: AsyncBelongsTo<Group>;

  @belongsTo('people-schema/set', { async: true, inverse: null })
  declare templateSetId: AsyncBelongsTo<Set>;

  // requiredRole specifies the Field Access role required to view this field,
  // if applicable.  If empty, anyone with access to the entity can see it.
  @attr('string', { defaultValue: '' })
  declare requiredRole: string;

  // isReadOnly specifies whether this field is read-only.
  @attr('boolean', { defaultValue: false })
  declare isReadOnly: boolean;

  // studentPermission specifies whether this field is available for the Calendar & Excursions feature
  @attr('boolean', { defaultValue: false })
  declare studentPermission: boolean;
}
